var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import TextareaAutosize from 'react-textarea-autosize';
/**
 * TextareaAutosize Wrapper Component
 * https://github.com/Andarist/react-textarea-autosize
 * NOTE: 使用機能を明確化するため、必要に応じて型定義を追加してください
 * WARNING: ライブラリ依存を避けるため、極力ページ内で直接MultiTextInputBaseを使用せず機能を制限した ui コンポーネントを作成し、それを利用してください
 */
export const MultiTextInputBase = (props) => {
    const { minRows } = props, textareaProps = __rest(props, ["minRows"]);
    return _jsx(TextareaAutosize, Object.assign({}, textareaProps, { minRows: minRows }));
};
